export function selectJosa(name: string, options: string[]) {
  const lastChar = name.charCodeAt(name.length - 1)
  const isThereLastChar = (lastChar - 0xac00) % 28
  if (isThereLastChar) {
    return options[0] ?? options[1] ?? ""
  }
  return options[1] ?? ""
}
